import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactLoading from "react-loading";
import { useParams } from "react-router-dom";
import exportValue from "../../apiconfig";
import Swal from "sweetalert2";

const Invoice_view = () => {
  const { invoice_id } = useParams();

  const [loading, setLoading] = useState(true);

  const [invoiceData, setInvoiceData] = useState({
    invoice: {},
    customer: {},
    company: {},
  });

  const STATE_CODES = {
    "JAMMU AND KASHMIR": "1",
    "HIMACHAL PRADESH": "2",
    PUNJAB: "3",
    CHANDIGARH: "4",
    UTTARAKHAND: "5",
    HARYANA: "6",
    DELHI: "7",
    RAJASTHAN: "8",
    "UTTAR PRADESH": "9",
    BIHAR: "10",
    SIKKIM: "11",
    "ARUNACHAL PRADESH": "12",
    NAGALAND: "13",
    MANIPUR: "14",
    MIZORAM: "15",
    TRIPURA: "16",
    MEGHALAYA: "17",
    ASSAM: "18",
    "WEST BENGAL": "19",
    JHARKHAND: "20",
    ORISSA: "21",
    ODISHA: "21",
    CHHATTISGARH: "22",
    "MADHYA PRADESH": "23",
    GUJARAT: "24",
    "DADRA AND NAGAR HAVELI & DAMAN AND DIU": "26",
    MAHARASHTRA: "27",
    KARNATAKA: "29",
    GOA: "30",
    LAKSHADWEEP: "31",
    KERALA: "32",
    "TAMIL NADU": "33",
    PUDUCHERRY: "34",
    "ANDAMAN AND NICOBAR": "35",
    TELANGANA: "36",
    "ANDHRA PRADESH": "37",
    LADAKH: "38",
    "OTHER TERRITORY": "97",
    "OTHER COUNTRY": "99",
  };
  useEffect(() => {
    getInvoice();
  }, [invoice_id]);

  const getInvoice = async () => {
    try {
      const response = await axios.post(
        exportValue.host +
          "/" +
          exportValue.version +
          "/" +
          exportValue.api +
          "/get_single_invoice",

        {
          invoice_id: invoice_id,
        },

        {
          headers: exportValue.headers,
        }
      );

      if (response.data.success) {
        setInvoiceData(response.data.data);
      }
    } catch (error) {
      console.log(error);

      Swal.fire("Error", "Unable to fetch invoice", "error");
    }

    setLoading(false);
  };
  const calculateDueDate = (initialDate, daysToAdd) => {
    const initialDateObject = new Date(initialDate);
    const dueDateObject = new Date(initialDateObject);
    dueDateObject.setDate(initialDateObject.getDate() + daysToAdd);

    // Format the due date to YYYY/MM/DD
    const formattedDueDate = `${dueDateObject.getFullYear()}-${
      dueDateObject.getMonth() + 1
    }-${dueDateObject.getDate()}`;

    return formattedDueDate;
  };
  const getStateCode = (stateName) => {
    console.log("stateName = ", stateName);
    if (!stateName) return "";
    console.log(
      "stateName = 2",
      STATE_CODES[String(stateName).trim().toUpperCase()] || ""
    );

    return STATE_CODES[String(stateName).trim().toUpperCase()] || "";
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <ReactLoading type="spin" color="#0d6efd" height={40} width={60} />
      </div>
    );
  }

  const { invoice, customer, company } = invoiceData;

  const isMaharashtraCustomer = () => {
    return customer?.state_name?.toLowerCase() === "maharashtra";
  };

  const gstAmount = Number(invoice?.igst || 0);

  const halfGst = gstAmount / 2;
  return (
    <div class="container mt-3 wrap">
      <div class="card mb-1">
        <div class="card-body">
          <div class="pb-5">
            <img
              src="../../../assets/img/logo_5.png"
              class="img-fluid"
              style={{ height: "70px" }}
            />
          </div>
          <div class="row">
            <div class="col-7">
              <div class="pb-4">
                <strong>{company.invoice_name}</strong>
                <br />
                {company.invoice_address}
                <br />
                Phone: {company.invoice_phone}
                <br />
                Email: {company.invoice_email}
              </div>
              <div>
                <strong>PAN Number:</strong> {company.invoice_pan}
                <br />
                <strong>CIN Number:</strong> {company.invoice_cin}
                <br />
                <strong>GSTIN:</strong> {company.invoice_gst}
                <br />
                <strong>IRN:</strong> {company.invoice_irn}
              </div>
            </div>
            <div class="col-5">
              <h6 class="pb-3">
                <strong>TAX INVOICE</strong>
              </h6>
              <h2 class="text-success">PAID</h2>
              <div class="download_btn">
                <a href="javascript:window.print();">Download Invoice</a>
              </div>
              <div class="pt-2">
                <strong>Invoice No. :</strong> {invoice.invoice_id}
                <br />
                <strong>Invoice Date :</strong> {invoice.invoice_date}
                <br />
                <strong>Due Date :</strong>{" "}
                {calculateDueDate(invoice.invoice_date, 15)}
                <br />
                <strong>Invoice Period : </strong>
                {(() => {
                  const getStartAndEndDates = (monthYear) => {
                    const [monthName, year] = monthYear.split(","); // Split month and year
                    const monthIndex = new Date(
                      `${monthName} 1, ${year}`
                    ).getMonth(); // Get zero-based month index
                    const startDate = new Date(year, monthIndex, 1); // First day of the month
                    const endDate = new Date(year, monthIndex + 1, 0); // Last day of the month

                    // Format date as YYYY-MM-DD
                    const formatDate = (date) => {
                      const year = date.getFullYear();
                      const month = String(date.getMonth() + 1).padStart(
                        2,
                        "0"
                      ); // Ensure 2 digits
                      const day = String(date.getDate()).padStart(2, "0"); // Ensure 2 digits
                      return `${year}-${month}-${day}`;
                    };

                    return `${formatDate(startDate)} to ${formatDate(endDate)}`; // Format range
                  };

                  return getStartAndEndDates(invoice.invoice_period); // Render period as range
                })()}
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-7">
              <strong>Invoice To:</strong>
              {customer.company_name
                ? customer.company_name
                : customer.full_name
                ? customer.full_name
                : ""}{" "}
              <br />
              {customer.address} <br />
              {customer.state_name ? customer.state_name : ""} ,{" "}
              {customer.city_name ? customer.city_name : ""}
            </div>
            <div className="col-5">
              <strong>GSTIN/PAN:</strong>{" "}
              {customer.gst_number &&
              customer.gst_number !== "undefined" &&
              customer.gst_number !== "null"
                ? customer.gst_number
                : customer.pan_number || ""}
              <br />
              <strong>State Code:</strong>{" "}
              {getStateCode(customer.place_of_supply)}
              <br />
              <strong>Place of Supply:</strong> {customer.place_of_supply || ""}
              <br />
              <strong>Reverse Charge:</strong> {customer.reverse_charge || "No"}
              <br />
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-1">
        <div class="card-body">
          <div class="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>SAC</th>

                  <th>Description</th>

                  <th>Amount</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>996812</td>

                  <td>Logistics Services</td>

                  <td>₹{Number(invoice.taxable_amount || 0).toFixed(2)}</td>
                </tr>

                {isMaharashtraCustomer() ? (
                  <>
                    <tr>
                      <td></td>
                      <td>CGST @ 9%</td>
                      <td>₹{invoice.cgst.toFixed(2)}</td>
                    </tr>

                    <tr>
                      <td></td>
                      <td>SGST @ 9%</td>
                      <td>₹{invoice.sgst.toFixed(2)}</td>
                    </tr>
                  </>
                ) : (
                  <tr>
                    <td></td>
                    <td>IGST @ 18%</td>
                    <td>₹{gstAmount.toFixed(2)}</td>
                  </tr>
                )}

                <tr>
                  <td colSpan="2">
                    <strong>Grand Total</strong>
                  </td>

                  <td>
                    <strong>
                      ₹{Number(invoice.total_amount || 0).toFixed(2)}
                    </strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="card mb-1">
        <div class="card-body">
          <div class="border-bottom py-2">
            <strong>Bank and Other Commercial Details</strong>
          </div>
          <div className="row">
            <div className="col-md-9">
              All Payments by transfer/check/DD should be draw in favour of{" "}
              <br />
              <strong>Entity Name:</strong> {company.entity_name} <br />
              <strong>Account number:</strong> {company.account_number} <br />
              <strong>Bank:</strong> {company.bank} <br />
              <strong>Branch:</strong> {company.branch} <br />
              <strong>RTGS/NEFT/IFSC Code:</strong> {company.ifsc_code}
            </div>
            <div className="col-md-3">
              <td colSpan="9">
                {/* {customer?.signature_image && ( */}
                <img
                  src="../../assets/img/signature.png"
                  alt="Sign"
                  style={{ width: "50%", height: "50%" }}
                />
                <br />
                <b>Authorized signatory</b>
                {/* )} */}
              </td>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invoice_view;
